'use client';

import { useStore } from '@mui/x-internals/store';
import { chatSelectors } from "../selectors/index.js";
import { useChatStore } from "./useChatStore.js";
export function useMessageIds() {
  const store = useChatStore();
  return useStore(store, chatSelectors.messageIds);
}
export function useMessage(id) {
  const store = useChatStore();
  const message = useStore(store, chatSelectors.message, id);
  return message ?? null;
}